import { RotateCw } from 'lucide-react';
import { useIsMoved } from '../../lib/movedFlash';

/**
 * Piccolo badge `↻` mostrato per 3s sulle righe MIT/Azione appena spostate
 * dal coach durante la chat. Aiuta l'utente a individuare dove è finita la
 * task nella lista senza dover cercare.
 *
 * Props:
 *  - id (obbligatorio): id della task. Il badge si mostra solo se l'id è
 *    nel set globale `movedFlash` (auto-clear dopo 3s).
 *  - testid: data-testid opzionale.
 */
export default function MovedBadge({ id, testid }) {
  const isMoved = useIsMoved(id);
  if (!isMoved) return null;
  return (
    <span
      key={id + '-moved'}
      className="qp-moved-badge shrink-0 inline-flex items-center gap-1 px-1.5 py-0.5 border border-accent text-accent font-mono text-[9px] uppercase tracking-[0.18em]"
      title="Appena spostata dal coach"
      aria-label="Task appena spostata dal coach"
      data-testid={testid || `moved-badge-${id}`}
    >
      <RotateCw size={9} strokeWidth={2} />
      spostata
    </span>
  );
}
